// project module routes
const PROJECT_GROUP_ID_ROUTES = {
  overview: {},
  setup: {},
  progress: {},
  portfolios: {},
  experiences: {},
  portfolioInsights: {},
  assessment: {},
  deadlines: {},
  insights: {},
  stimuliSetup: {},
  guidance: {
    supervisor: {},
  },
  bin: {},
};

const PROJECT_GROUP_TYPE_ROUTES = {
  projects: {
    projectGroup: PROJECT_GROUP_ID_ROUTES,
  },
};

const PROJECTS_IA_EA_ROUTES = {
  projectGroup: PROJECT_GROUP_ID_ROUTES,
};

/**
 * Temporary map till permission is not enabled
 */
export const NESTED_ROUTE_MAPPINGS_FOR_GLOBAL_HEADER_LOCAL = {
  "": {
    platform: {
      curriculumProgramId: {
        courses: {},
      },
      "admin-home": {},
      administrator: {},
      accountSettings: {
        "*": {},
      },
      coreSettings: {
        "*": {},
      },
      academic: {
        academicId: {
          "*": {},
        },
      },
      school: {
        schoolId: {
          "*": {},
        },
      },
      academicAccountPortal: {
        academicId: {
          "*": {},
        },
      },
      "my-home": {},
    },
    "toddle-library": {
      "*": {},
    },
    admissions: {
      "*": {},
    },
  },
};

const CLASS_SETTINGS_ROUTES = {
  students: {},
  "family-members": {},
  teachers: {},
  journal: {},
  "timetable-configuration": {},
  module: {},
};

const SUBJECT_SETTINGS_ROUTES = {
  "assessment-categories": {},
  "grade-boundaries": {},
  "myp-criteria-configuration": {},
  "grading-configurations": {},
  "grading-visibility": {},
};

const COURSE_ROUTES = {
  unitPlans: {
    cardView: {},
    timelineView: {},
    courseOverview: {},
  },
  scheduler: {
    weekly: {},
  },
  "class-planners": {},
  "weekly-planners": {},
  "class-flow": {},
  "dp-learning-standards": {},
  "ubd-learning-standards": {},
  scopeandsequence: {},
  planningInsights: {},
  "learning-standards": {},
  projects: PROJECTS_IA_EA_ROUTES,
  practicalactivities: {},
  classroom: {
    insights: {},
  },
  recordofexperimentalprogrammes: {},
  journal: {},
  routines: {},
  "my-calendar": {},
  "student-drive": {
    nodeId: {},
  },
  attendance: {
    excusals: {},
    insights: {},
  },
  progressreport: {},
  gradebook: {
    assessments: {},
    "learning-goals": {
      "assessment-objectives": {},
      "subjects-standards": {},
      atls: {},
      lpas: {},
      "learner-profile": {},
      "key-concepts": {},
    },
    standards: {},
    "final-grades": {},
  },
  continuum: {},
  teacherpolicies: {},
  teacherresources: {},
  unitlibrary: {},
  lelibrary: {},
  "class-settings": CLASS_SETTINGS_ROUTES,
  "subject-settings": {
    subjects: {
      subjectId: SUBJECT_SETTINGS_ROUTES,
    },
  },
  "recycle-bin": {},
  "lti-tools": {
    "*": {},
  },
  workflows: {},
  circulars: {
    circular_id: {},
    search: {},
  },
};

const LEARNING_COURSE_ROUTES = {
  home: {},
  "course-home": {},
  unit: {
    cardView: {},
    timelineView: {},
    courseOverview: {},
  },
  "lti-tools": {
    "*": {},
  },
  "course-flow": {},
  "course-plan": {
    flow: {},
    card: {},
    table: {},
    timeline: {},
    schedule: {},
  },
  schedule: {},
  sync: {
    "*": {},
  },
  "assessment-tools-setup": {},
  "course-settings": {
    "*": {},
  },
  "subject-settings": {
    subjectId: SUBJECT_SETTINGS_ROUTES,
  },
  class: {
    course_id: COURSE_ROUTES,
  },
  "class-settings": {
    course_id: CLASS_SETTINGS_ROUTES,
  },
  standards: {
    standardSetId: {},
  },
};

const PROGRAM_ROUTES = {
  courses: {
    course_id: COURSE_ROUTES,
    "my-calendar": {},
  },
  circulars: {
    circular_id: {},
    search: {},
  },
  educatorcenter_v2: {
    nodeId: {},
  },
  "attendance-dashboard": {},
  classroomTodos: {},
  familyconversations: {
    familyCommunicationId: {},
  },
  "teacher-timetable": {},
  snp_v2: {},
  snp: {},
  goals: {},
  homeroom: {},
  "progress-report-sets": {},
  "project-group-types": {
    projectGroupType: PROJECT_GROUP_TYPE_ROUTES,
  },
  "subject-center": {},
  insights: {},
  "class-stream-manager": {},
  "toddle-insights": {
    "*": {},
  },
  "behaviour-management": {
    dashboard: {
      sectionId: {},
    },
    "behaviour-configuration": {
      categories: {},
      severities: {},
      actions: {},
      locations: {},
      "default-outcomes": {},
      nomenclature: {},
    },
  },
  "school-library": {
    units: {},
    tasks: {},
  },
  "learning-course": {
    learningCourseId: LEARNING_COURSE_ROUTES,
  },
  "learning-courses": {
    "*": {},
  },
  "curriculum-insights": {
    "*": {},
  },
  "curriculum-publishing": {
    "*": {},
  },
  class: {
    course_id: {},
  },
  bin: {},
  messaging: {
    chatId: {},
    searchv2: {
      members: {},
      messages: {},
      channels: {},
      files: {},
    },
    "public-channels": {},
    monitor: {
      chatId: {},
    },
    forms: {
      formId: {},
    },
    "form-templates": {
      templateId: {},
    },
    "staff-directory": {},
    "flagged-messages": {},
    "volume-insights": {},
    "module-settings": {},
  },
  educatorcenter: {
    teacherresources: {},
    parentresources: {},
    adminresources: {},
    teacherpolicies: {},
    parentpolicies: {},
  },
  "content-skills": {
    scopeandsequence: {},
  },
  "unit-publishing": {},
  yearGroup: {
    yearGroupId: {
      planningInsights: {},
    },
  },
  planningInsights: {},
  gradebook: {
    yearGroupId: {
      "*": {},
    },
  },
};

const REPORTING_SETUP_ROUTES = {
  "*": {},
  progressreporttemplate: {
    "list-view": {},
  },
  reporttasks: {},
};

/**
 * This object is the representation of routes used in web-app. It is used to
 * determine whether global header is present on a given route or not. For every path which is
 * present in the object, global header will be shown.
 */
export const NESTED_ROUTE_MAPPINGS_FOR_GLOBAL_HEADER = {
  "": {
    platform: {
      curriculumProgramId: PROGRAM_ROUTES,
      "admin-home": {},
      administrator: {},
      accountSettings: {
        "*": {},
      },
      coreSettings: {
        "*": {},
      },
      academic: {
        academicId: {
          "*": {},
        },
      },
      school: {
        schoolId: {
          "*": {},
          "reporting-setup": REPORTING_SETUP_ROUTES,
        },
      },
      academicAccountPortal: {
        academicId: {
          "*": {},
        },
      },
      "my-home": PROGRAM_ROUTES,
      workflow: {
        job_id: {},
      },
    },
    "toddle-library": {
      "*": {},
    },
    admissions: {
      "*": {},
    },
  },
};
